import { IOHelper, utils } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class IntegerContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.Integer;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfVarBytesLE(utils.toSignedBuffer(this.value)));
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        super.deserializeContractParameterBaseWireBase(options);
        const value = utils.fromSignedBuffer(reader.readVarBytesLE());
        return new this(value);
    }
    get size() {
        return this.sizeInternal();
    }
    asBoolean() {
        return !this.value.isZero();
    }
    asBuffer() {
        return utils.toSignedBuffer(this.value);
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeVarBytesLE(utils.toSignedBuffer(this.value));
    }
    serializeJSON(_context) {
        return {
            type: 'Integer',
            value: this.value.toString(10),
        };
    }
}

//# sourceMappingURL=IntegerContractParameter.js.map
